module.exports = __webpack_public_path__ + "images/color-fun-6-cc10041971f68ee0968862caaf7a7c72.jpg";